import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4l0 -8","key":"svg-0"}],["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-1"}],["path",{"d":"M16.5 7.5v.01","key":"svg-2"}]]

const IconBrandInstagram = createReactComponent('outline', 'brand-instagram', 'BrandInstagram', __iconNode);

export default IconBrandInstagram;